import * as React from "react";
const IconAssignToYou = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx={9.64319}
      cy={17.4924}
      rx={7}
      ry={3.5}
      stroke="#1C1C2C"
      strokeWidth={1.3}
      strokeLinejoin="round"
    />
    <circle
      cx={9.64319}
      cy={6.99243}
      r={4}
      stroke="#1C1C2C"
      strokeWidth={1.3}
      strokeLinejoin="round"
    />
    <path
      d="M17.579 13.9924L14.9672 11.3806M14.9672 11.3806L17.579 8.7688M14.9672 11.3806L22.8026 11.3806"
      stroke="#1C1C2C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconAssignToYou;
